import { createAction } from '@reduxjs/toolkit';

export const FETCH_CRM_CATALOG = 'FETCH_CRM_CATALOG';
export const fetchCrmCatalogAction = createAction(FETCH_CRM_CATALOG);
